<template>
  <div class="fill-height">


    <v-card class="fill-height">

      <v-card-title  class="p-1">
        <v-chip
            label    small
            class="ma-2"
            color="secondary">
          اطلاعات تکمیلی
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="$router.go(-1)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
<!--      <v-toolbar dark style="display: block" dense color="#1e45c7">-->
<!--        <v-toolbar-title>اطلاعات تکمیلی</v-toolbar-title>-->
<!--        <v-spacer/>-->
<!--        <v-btn dark small icon depressed style="background-color:#be1e0b" @click="$router.push('/home')">-->
<!--          <v-icon>mdi-close</v-icon>-->
<!--        </v-btn>-->
<!--      </v-toolbar>-->

      <v-card-text>
        <v-row>
          <v-col cols="12"
                 sm="2"
                 v-if="can('furtherInformation')" class="d-inline-block">
            <v-btn class="float-right "
                   color="primary"
                   right
                   fab
                   small
                   @click="forNew()"
            >
              <v-icon>fa fa-edit</v-icon>
            </v-btn>
            <div v-if="showDialog">
              <edit-information :model="model" :dialogStatus.sync="showDialog"/>
            </div>

          </v-col>
        </v-row>

        <v-row >
          <v-col cols="12"
                 sm="12"
                 md="3">
            <label> نام مجتمع : {{ model.unit.building.name }}</label>
          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="3">
            <label> نام واحد:{{ model.unit.unitName }}</label>
          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="3">
            <label> نام شخص:{{ model.user.person.fullName }}</label>
          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="3">
            <label>
              تلفن همراه:{{ model.user.person.mobile }}
            </label>
          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="3">
            <label>وضعیت استقرار:{{ stabilityStatus[model.stabilityStatusText] }}</label>
          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="3">
            <label> تاریخ استقرار:{{ model.stabilityText }}</label>
          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="3" v-for="(info,i) in model.informationList" :key="i">
            <label>{{ info.title }}:{{ info.description }}</label>
          </v-col>
        </v-row>


      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {mapMutations} from "vuex";
import EditInformation from './PageEditInformation'
import Unit_se from "@/views/define/establishment/Unit_se";

const stabilityStatus = Object.freeze({
  based: "مستقر است",
  leave: "ترک کرده",
  empty: "خالی است"
});
export default {
  name: 'Establishment',
  components: {
    EditInformation
  },
  data() {
    return {
      stabilityStatus,
      id: '',
      model: '',
      showDialog: false,
    };

  },

  mounted() {
    this.$root.$on('Information', () => {
      this.forEdit()
    })

  },

  methods: {
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),


    forEdit: function () {
      this.id = this.$route.query.id
      this.modelId = this.id;
      Unit_se.getById(this.modelId).then(response => {
        this.model = response.data.model
      })
    },

    forNew: function () {
      this.showDialog = true
    },


  },

  created() {
    this.id = this.$route.query.id
    this.forEdit()
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
